import { render, staticRenderFns } from "./updaet-address.vue?vue&type=template&id=0c75880c&scoped=true"
import script from "./updaet-address.vue?vue&type=script&lang=ts"
export * from "./updaet-address.vue?vue&type=script&lang=ts"
import style0 from "./updaet-address.vue?vue&type=style&index=0&id=0c75880c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c75880c",
  null
  
)

export default component.exports